import '../sass/app.scss';
import './blocks';

/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
jQuery(document).ready(function ($) {
	$('.dropdown-toggle').on('click', function (e) {
		e.preventDefault();
		$('#userDropdown').toggle();
	});

	// Close dropdown when clicking outside
	$(document).on('click', function (event) {
		if (!$(event.target).closest('.user-dropdown').length) {
			$('#userDropdown:visible').hide();
		}
	});
	$('.video-overlay').each(function () {
		let playButton = $(this);
		let section = playButton.closest('section');
		// Use class-based selectors instead of IDs
		const videoWrapper = section.find('.custom-video-wrapper');
		const videoElement = section.find('.custom-video-iframe')[0]; // Assuming you're using a class for the iframe

		// Check if the play button (video overlay) exists
		if (playButton.length > 0) {
			// Initialize MediaElementPlayer
			const player = new MediaElementPlayer(videoElement, {
				success: function (mediaElement, originalNode, instance) {
					// Play video on button click
					let button = section.find('.custom-play-button');
					let videoContainer = section.find('.mejs-container');

					button.on('click', function () {
						playButton.hide();
						$(videoElement).show();
						videoWrapper.removeClass('paused');
						videoContainer.show();
						player.play();
					});

					// Show play button on pause
					mediaElement.addEventListener('pause', function () {
						videoContainer.hide();
						playButton.css('display', 'flex');
						$(videoElement).hide();
						videoWrapper.addClass('paused');
					});
				},
			});
		}
	});
	// $('#ajax-comment-form').submit(function(e) {
	// 	e.preventDefault(); // Prevent the default form submission
	// 	$('#error-description').html('').addClass('hidden');
	// 	var formData = $(this).serialize(); // Serialize form data
	//
	// 	$.ajax({
	// 		url: ajax_comment_params.ajax_url, // AJAX URL
	// 		type: 'POST',
	// 		dataType: 'json',
	// 		data: formData + '&action=ajax_submit_comment&security=' + ajax_comment_params.nonce, // Append action and security
	// 		success: function(response) {
	// 			if (response.success) {
	// 				// Append the new comment to the comment list
	// 				$('.comment-list').append(response.data);
	// 				$('#ajax-comment-form')[0].reset(); // Reset the form
	// 			} else {
	// 				$('#error-description').html(response.data).removeClass('hidden');
	// 				// alert(response.data); // Display any errors
	// 			}
	// 		},
	// 		error: function() {
	// 			alert('Error posting comment');
	// 		}
	// 	});
	// });
});

/* eslint-enable no-undef */
/* eslint-enable no-unused-vars */
